import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber',
  standalone: true,
})
export class FormatNumberPipe implements PipeTransform {
  /**
   * @description Redondea a dos decimales y aplica formato en-US.
   * @param value El numero a formatear.
   * @returns El numero formateado como string.
   */
  transform(value: number): string {
    if (value == null) return '';

    // Redondear a dos decimales
    const roundedValue = Math.round(value * 100) / 100;

    // Convertir a string con separacion de miles
    const formattedValue = roundedValue
      .toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      .replace(/\u00A0/g, ' '); // Reemplazar espacios no separables con espacios normales.

    return formattedValue;
  }
}
